import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Feed.svg'

export const IconFeed = IconSVG as IconComponent
